var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('job_lists.settings.delete.confirmation_description')))]),_vm._v(" "),_c('p',{staticClass:"font-semibold mt-sm"},[_vm._v("\n        "+_vm._s(_vm.$tc('job_lists.settings.delete.confirmation_disclaimer', 0, { job_list_name: _vm.jobList.name }))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }